import { createFileRoute, redirect } from "@tanstack/react-router";

// Old URL: kept so bookmarks and links land on the matching settings tab.
export const Route = createFileRoute("/$store/_layout/settings_/api")({
	beforeLoad: ({ params }) => {
		throw redirect({
			to: "/$store/settings",
			params: { store: params.store },
			search: { aba: "integracoes" },
			replace: true,
		});
	},
});
